import Papa from 'papaparse';

/**
 * Triggers a browser download of a CSV string (UTF-8). Prefer {@link downloadCsvFile} when data is tabular.
 */
export function downloadCsvFromString(csvContent: string, filename: string): void {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}

/**
 * Downloads a CSV template containing only headers (no data rows).
 * @param headers - Array of column header strings
 * @param filename - The download filename (e.g., 'bulk_credit_allocation_template.csv')
 */
export function downloadCsvTemplate(headers: Array<string>, filename: string): void {
  const csvContent = Papa.unparse({ fields: headers, data: [] });
  downloadCsvFromString(csvContent, filename);
}

/**
 * Pure CSV serialiser. Returns a CSV string for the given rows and column ordering.
 * Independently testable without any DOM or Blob/URL mocking.
 * @param rows - Array of objects representing CSV rows
 * @param headers - Array of column header strings (controls column order)
 */
export function serialiseCsv(rows: Array<Record<string, unknown>>, headers: Array<string>): string {
  return Papa.unparse(rows, { columns: headers });
}

/**
 * Downloads an array of row objects as a CSV file.
 * @param rows - Array of objects representing CSV rows
 * @param headers - Array of column header strings (controls column order)
 * @param filename - The download filename
 */
export function downloadCsvFile(rows: Array<Record<string, unknown>>, headers: Array<string>, filename: string): void {
  const csvContent = serialiseCsv(rows, headers);
  downloadCsvFromString(csvContent, filename);
}
